import { useMemo } from 'react';
import { IEnvironmentVariablesResponse } from '../../types/environment/IEnvironmentVariablesResponse';
import { useGetEnvironmentVariablesQuery } from 'API/BaseApi';

interface EnvironmentVariablesState {
  data?: IEnvironmentVariablesResponse;
  hostname: string;
}
export const useEnvironmentVariables = (): EnvironmentVariablesState => {
  const { data } = useGetEnvironmentVariablesQuery();
  return useMemo(() => ({ data, hostname: window.location.hostname }), [data]);
};
